'use strict';

// リーグ編集画面（/leagues/:id/edit）の未保存変更ガード
// - フォームの入力状態をスナップショットし、変更後にページ内リンクを踏んだら確認シートを出す
// - シートは「キャンセル / 破棄して移動 / 保存して移動」の3択
// - ブラウザのリロード・タブ閉じは beforeunload で警告する
// turbolinks:load でバインド、turbolinks:before-cache でクリーンアップ

(function () {
  let form = null;
  let overlay = null;
  let initialSignature = '';
  let bypassGuard = false;
  let pendingUrl = null;
  let pendingTurbolinksDisabled = false;

  // フォーム内の入力値からスナップショット文字列を作る（DOM順のまま。ソートしない）
  // タイトル設定はドラッグ並べ替えで順序自体が変更点になるため
  function signature(targetForm) {
    const parts = [];
    const elements = targetForm.querySelectorAll('input, select, textarea');

    elements.forEach(function (el) {
      const name = el.name;
      if (!name) return;
      if (el.type === 'submit' || el.type === 'button') return;
      if (name === 'authenticity_token' || name === '_method' || name === 'utf8' || name === 'return_to') return;

      if (el.type === 'checkbox' || el.type === 'radio') {
        parts.push(name + '=' + el.value + ':' + (el.checked ? 1 : 0));
      } else if (el.type === 'file') {
        const files = el.files ? Array.prototype.slice.call(el.files) : [];
        const fileInfo = files.map(function (file) { return file.name + ':' + file.size; }).join(',');
        parts.push(name + '=' + fileInfo);
      } else {
        parts.push(name + '=' + el.value);
      }
    });

    return parts.join('|');
  }

  function isDirty() {
    return signature(form) !== initialSignature;
  }

  // ブラウザ離脱（リロード・閉じる等）を検知してガードする
  function onBeforeUnload(e) {
    if (!bypassGuard && isDirty()) {
      e.preventDefault();
      e.returnValue = '';
      return '';
    }
  }

  function openSheet() {
    overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    overlay.classList.remove('show');
    document.body.style.overflow = '';
  }

  // 確認シートで「移動する」系のボタンを押した後の実際の遷移
  function visit(url, turbolinksDisabled) {
    if (turbolinksDisabled || !window.Turbolinks || !window.Turbolinks.visit) {
      window.location.href = url;
    } else {
      window.Turbolinks.visit(url);
    }
  }

  function init() {
    form = document.getElementById('league-form');
    overlay = document.getElementById('league-leave-guard-overlay');
    // リーグ新規作成画面にも #league-form はあるが #league-leave-guard-overlay は無いため、
    // overlay も必須にすることでこのガードは編集画面限定になる
    if (!form || !overlay) {
      form = null;
      overlay = null;
      return;
    }

    initialSignature = signature(form);
    bypassGuard = false;
    pendingUrl = null;
    pendingTurbolinksDisabled = false;

    window.addEventListener('beforeunload', onBeforeUnload);

    // form_validation.js 等が preventDefault した場合はガードを生かしたままにする
    form.addEventListener('submit', function (e) {
      if (!e.defaultPrevented) bypassGuard = true;
    });

    // ページ内リンク遷移の割り込み（イベント委譲。init のたびに張り直す）
    $(document).off('click.leagueLeaveGuard');
    $(document).on('click.leagueLeaveGuard', 'a[href]', function (e) {
      if (bypassGuard) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.which === 2) return;
      if (this.target === '_blank') return;

      const rawHref = this.getAttribute('href');
      if (!rawHref || rawHref.charAt(0) === '#' || /^javascript:/i.test(rawHref)) return;
      if (this.dataset.method || this.dataset.remote === 'true' || this.dataset.confirm) return;
      if (!isDirty()) return;

      const url = new URL(this.href, window.location.href);
      if (url.origin !== window.location.origin) return;

      e.preventDefault();
      e.stopPropagation();

      pendingUrl = url.pathname + url.search + url.hash;
      pendingTurbolinksDisabled = this.dataset.turbolinks === 'false';
      openSheet();
    });

    // オーバーレイ自身のクリックで閉じる
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSheet();
    });

    // Escapeキーで閉じる
    document.addEventListener('keydown', handleEscape);

    // 「キャンセル」「閉じる」: シートを閉じるだけ（ページに留まる）
    overlay.querySelectorAll('.js-leave-guard-close').forEach(function (btn) {
      btn.addEventListener('click', closeSheet);
    });

    // 「破棄して移動」: 変更を破棄してそのまま遷移する
    const discardBtn = overlay.querySelector('.js-leave-guard-discard');
    if (discardBtn) {
      discardBtn.addEventListener('click', function () {
        bypassGuard = true;
        window.removeEventListener('beforeunload', onBeforeUnload);
        closeSheet();
        if (pendingUrl) visit(pendingUrl, pendingTurbolinksDisabled);
      });
    }

    // 「保存して移動」: フォームを送信し、保存成功後に目的のページへ遷移する
    const saveBtn = overlay.querySelector('.js-leave-guard-save');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        const returnToField = document.getElementById('league-return-to');
        if (returnToField && pendingUrl) returnToField.value = pendingUrl;
        closeSheet();

        if (form.requestSubmit) {
          // requestSubmit は submit イベントを発火するため、form_validation.js のバリデーションと
          // loading.js のローダー制御がそのまま働く。バリデーション失敗時は submit の
          // defaultPrevented が立つため、上の submit リスナーにより bypassGuard は立たない
          form.requestSubmit();
        } else {
          bypassGuard = true;
          window.removeEventListener('beforeunload', onBeforeUnload);
          form.submit();
        }
      });
    }
  }

  function handleEscape(e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('show')) closeSheet();
  }

  document.addEventListener('turbolinks:load', init);

  document.addEventListener('turbolinks:before-cache', function () {
    if (overlay) closeSheet();
    window.removeEventListener('beforeunload', onBeforeUnload);
    document.removeEventListener('keydown', handleEscape);
    $(document).off('click.leagueLeaveGuard');
    form = null;
    overlay = null;
    bypassGuard = false;
    pendingUrl = null;
    pendingTurbolinksDisabled = false;
  });
})();
